import {
    CREATE_SECTION_FAILURE,
    CREATE_SECTION_REQUEST,
    CREATE_SECTION_SUCCESS,
    CREATE_USER_FORM_SECTION,
    DELETE_SECTION_FAILURE,
    DELETE_SECTION_REQUEST,
    DELETE_SECTION_SUCCESS,
    FETCH_SECTION_FAILURE,
    FETCH_SECTION_REQUEST,
    FETCH_SECTION_SUCCESS,
    FETCH_SINGLE_SECTION_FAILURE,
    FETCH_SINGLE_SECTION_REQUEST,
    FETCH_SINGLE_SECTION_SUCCESS,
    RESET_SECTION_USER_FORM,
    UPDATE_SECTION_FAILURE,
    UPDATE_SECTION_REQUEST,
    UPDATE_SECTION_SUCCESS
} from './section.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchRolesOrSection } from '../roles/roles.actions';
import { fetchCompanyMaster } from '../companyMaster/companyMaster.actions';
import { fetchUnitMasterByCompanyId } from '../unitMaster/unitMaster.actions';

// FETCH AREA MASTER
export let fetchSection = () => {
    let config = {
        method: 'get',
        url: ConstantApi.sectionGET,
        responseTypeRequest: FETCH_SECTION_REQUEST,
        responseTypeSuccess: FETCH_SECTION_SUCCESS,
        responseTypeFailure: FETCH_SECTION_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createSectionUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_SECTION, payload: { key, value } });
    };
};

// CREATE AREA MASTER
//   "fldId": 0,
//   "fldFKSleeveType": 0,
//   "fldFKNeckType": 0,
//   "fldFKTypeOfFit": 0,
//   "fldFKYarn": 0,
//   "fldFKFabricType": 0,
//   "fldIsActive": true,
//   "fldEnteredSysId": "string",
//   "fldCreatedBy": 0,
//   "fldCreatedDt": "2022-07-29T12:06:16.995Z",
//   "fldPreparedBy": "string",
//   "fldPreparedOn": "2022-07-29T12:06:16.995Z",
//   "fldIsVerified": true,
//   "fldVerifiedBy": "string",
//   "fldVerifiedOn": "2022-07-29T12:06:16.995Z",
//   "fldIsAuthorized": true,
//   "fldAuthorizedBy": "string",
//   "fldAuthorizedOn": "2022-07-29T12:06:16.995Z"

export let createSection = (userform, modalClose) => {
    console.log('userform action>>>>>>>>>>>>', userform);
    let { fldFKSleeveType, fldFKNeckType, fldFKTypeOfFit, ipv4, fldFKYarn, fldFKFabricType } = userform;
    let today = new Date();
    let data = JSON.stringify({
        fldFKCompanyMaster: parseInt(userform.fldFKCompanyMaster),
        fldFKUnitMaster: parseInt(userform.fldFKUnitMaster),
        fldFKSection: parseInt(userform.fldFKSection),
        fldSectionType: userform.fldSectionType,
        fldIsActive: true,
        fldEnteredSysId: userform.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldSection: '',
        FldUnitTypeDetails: 'string'
    });
    console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.sectionPOST}`,
        responseTypeRequest: CREATE_SECTION_REQUEST,
        responseTypeSuccess: CREATE_SECTION_SUCCESS,
        responseTypeFailure: CREATE_SECTION_FAILURE,
        resetFormData: RESET_SECTION_USER_FORM,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSection()
    };
    return axiosCall(config);
};

// GET SINGLE AREA MASTER
export let getSectionById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sectionGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_SECTION_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_SECTION_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_SECTION_FAILURE,
        singlApiArray: [fetchRolesOrSection(34), fetchCompanyMaster()]
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER

//     "fldId": 3,
//     "fldFKCountry": 1045,
//     "fldCountry": "India1",
//     "fldFKState": 4,
//     "fldState": "TN",
//     "fldFKCity": 1045,
//     "fldCity": "TUP",
//     "fldFKArea": 1045,
//     "fldArea": "SAP",
//     "fldFKPincode": 1045,
//     "fldPincode": "641-652",
//     "fldIsActive": true,
//     "fldEnteredSysId": "192.16.12.170",
//     "fldCreatedBy": 1,
//     "fldCreatedDt": "2022-05-16T09:48:03.527",
//     "fldModifiedBy": 0,
//     "fldModifiedDt": "0001-01-01T00:00:00",
//     "fldDeletedBy": 0,
//     "fldDeletedDt": "0001-01-01T00:00:00"

export let updateSection = (id, formData) => {
    let { fldFKCompanyMaster, fldFKUnitMaster, fldFKSection, ipv4, fldSectionType, fldCreatedBy, fldCreatedDt, fldModifiedBy } = formData;
    let today = new Date();
    let data = JSON.stringify({
        fldId: id,
        fldFKCompanyMaster: parseInt(fldFKCompanyMaster),
        fldFKUnitMaster: parseInt(fldFKUnitMaster),
        fldFKSection: parseInt(fldFKSection),
        fldSectionType: fldSectionType,
        fldIsActive: true,
        fldEnteredSysId: ipv4,
        fldCreatedBy: fldCreatedBy,
        fldCreatedDt: fldCreatedDt,
        fldModifiedBy: fldModifiedBy,
        fldModifiedDt: today.toISOString,
        fldSection: '',
        FldUnitTypeDetails: formData.fldUnitTypeDetails
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.sectionPATCH}/${id}`,
        responseTypeRequest: UPDATE_SECTION_REQUEST,
        responseTypeSuccess: UPDATE_SECTION_SUCCESS,
        responseTypeFailure: UPDATE_SECTION_FAILURE,
        resetFormData: RESET_SECTION_USER_FORM,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSection()
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteSection = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.sectionDELETE}/${id}`,
        responseTypeRequest: DELETE_SECTION_REQUEST,
        responseTypeSuccess: DELETE_SECTION_SUCCESS,
        responseTypeFailure: DELETE_SECTION_FAILURE,
        modalClose: true,
        getAllData: fetchSection()
    };
    return axiosCall(config);
};
